import { ProductController, UserController } from "controllers";

const DeleteItemButton = ({ customer, box, item, onDelete }) => {

    const handleClick = async () => {
        if (!window.confirm(`Are you sure you want to remove ${item.barcode} from the box?`)) {
            return;
        }

        await UserController.deleteUserBoxItems(customer.id, box.id, item.id)

        const payload = { currentUser: null, currentBox: null, status: "available" }
        await ProductController.editProduct(item.barcode, payload);
        await ProductController.deleteProductLog(item.barcode, box.id);

        if (onDelete) { onDelete(); }
    }

    return (
        <small>
            <span className="icon-text is-clickable" onClick={handleClick}>
                <span className="icon has-text-danger">
                    <i className="fas fa-trash"></i>
                </span>
                <span className="is-hidden-mobile">
                    Delete
                </span>
            </span>
        </small>
    );
}

export { DeleteItemButton };
